module.exports = __webpack_public_path__ + "static/media/cross.704fd668.svg";